// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './authentication'
import promoters from '@src/views/promoters/store'
import users from "@src/views/users/store"
import roles from "@src/views/roles/store"
import discounts from "@src/views/discounts/store"
import dashboard from "@src/views/dashboard/store"
import sellers from "@src/views/sellers/store"
import detailOrders from "@src/views/detailOrder/store"
import store from "@src/views/store/store"
import products from "@src/views/products/store"

const rootReducer = {
  auth,
  navbar,
  layout,
  promoters,
  users,
  roles,
  discounts,
  dashboard,
  sellers,
  detailOrders,
  store,
  products
}

export default rootReducer
